import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 10px;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const Button = styled.button`
  padding: 10px;
  background-color: #4caf50;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const SuccessMessage = styled.p`
  margin-top: 20px;
  text-align: center;
  color: #4caf50;
`;

const ErrorMessage = styled.p`
  margin-top: 20px;
  text-align: center;
  color: #ff0000;
`;

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Invalid email address');
      return;
    }

    // Simulate successful email sending
    setTimeout(() => {
      setSuccess(true);
      setEmail('');
      setError('');
    }, 1000);
  };

  return (
    <Container>
      <Title>Forgot Password</Title>
      {success ? (
        <SuccessMessage>
          Password reset email sent successfully!
        </SuccessMessage>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Label>
            Email:
            <Input type="email" value={email} onChange={handleEmailChange} />
          </Label>
          <Button type="submit">Reset Password</Button>
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </Form>
      )}
    </Container>
  );
};

export default ForgetPassword;
